export default __webpack_public_path__ + "static/media/delete.440ee7e4.svg";